import Text from '../../components/Text/Text';
import useCart from '../Cart/useCart';

function StoreName() {
  const { storeName } = useCart();

  return <Text type="title">{storeName}</Text>;
}

export default StoreName;
